import styled from "styled-components";

export const ContainerSearch = styled.div<{
  children: any;
}>`
  height: 20px;
  display: flex;
  margin: 20px 0px;
  justify-content: flex-end;
`;

export const ContainerDataRepair = styled.div<{
  children: any;
}>`
  display: block !important;
  width: 80% !important;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
`;
export const ContainerShowDetail = styled.div<{
  children: any;
}>`
  width: 60%;
`;
export const ContainerTimelineDetail = styled.div<{
  children: any;
}>`
  display: block;
  width: 40%;
`;
export const ContainerEditModalRepair = styled.div<{
  children: any;
}>`
  display: flex;
  width: 100%;
`;
export const ContainerImageAndForm = styled.div<{
  children: any;
}>`
  display: flex;
  width: 60%;
`;

export const ContainerConfirmGetJob = styled.div<{
  children: any;
}>`
  display: flex;
  justify-content: flex-end;
`;
export const ContainerModalFooter = styled.div<{
  children: any;
}>`
  display: flex;
  justify-content: space-between;
`;
export const ContainerModalFooterSingle = styled.div<{
  children: any;
}>`
  display: flex;
  justify-content: flex-end;
`;

export const StyledTimeline = styled.div<{
  children: any;
}>`
  display: block;
  width: 100%;
  margin-left: 16px;
`;

export const DivButtonExportFile = styled.div<{
  children: any;
}>`
  display: flex !important;
  justify-content: flex-end;
  margin-bottom: 5px
`;
